import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import HugggListButton from './HugggListButton/HugggListButton';

import styles from './huggg-list.module.scss';
import dictionary from 'config/dictionary';

export const HugggList = (props) => {
  const { history, hugggs, fetchHuggg, hasLoaded } = props;

  const onLinkClick = (event, huggg) => {
    event.preventDefault();

    fetchHuggg(huggg.shortcode);
    history.push(`/${huggg.shortcode}`);
  };

  return (
    <div className={styles.container}>
      <TransitionGroup
        component={hugggs.length ? 'ul' : 'div'}
        className={styles.list}
      >
        {!hugggs.length && hasLoaded && (
          <CSSTransition
            classNames={{
              enter: styles.enter,
              enterActive: styles.enterActive,
              enterDone: styles.enterDone,
              exit: styles.exit,
              exitActive: styles.exitActive,
            }}
            timeout={500}
          >
            <div className={styles.noHugggs} data-test-id="huggglist-no-hugggs">
              {dictionary.myHugggs.noHugggs}
            </div>
          </CSSTransition>
        )}

        {Boolean(hugggs.length) &&
          hasLoaded &&
          hugggs.map((huggg, index) => (
            <CSSTransition
              classNames={{
                enter: styles.enter,
                enterActive: styles.enterActive,
                enterDone: styles.enterDone,
                exit: styles.exit,
                exitActive: styles.exitActive,
              }}
              key={huggg.id}
              timeout={index * 50}
            >
              <li
                className={styles.listItem}
                style={{ transitionDelay: `${index * 50}ms` }}
                data-test-id="huggglist-item"
              >
                <HugggListButton
                  huggg={huggg}
                  onClick={onLinkClick}
                  data-test-id="huggglist-button"
                />
              </li>
            </CSSTransition>
          ))}
      </TransitionGroup>
    </div>
  );
};

HugggList.propTypes = {
  hasLoaded: PropTypes.bool.isRequired,
  hugggs: PropTypes.array.isRequired,
  fetchHuggg: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(HugggList);
